import type { ReactNode } from 'react';

/**
 * 折りたたみの説明ブロック。
 *
 * このページは「小さな道具」であることが第一なので、解説・注意事項・FAQ は
 * 既定で閉じておき、ツール本体の面積を奪わないようにする。
 * `<details>` の中身は HTML に出力されるため、検索エンジンからは読める。
 */
export function Disclosure({
  summary,
  children,
  id,
}: {
  summary: string;
  children: ReactNode;
  id?: string;
}) {
  return (
    <details id={id} className="group border-b border-line">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-3 py-3.5 text-[15px] font-bold text-ink hover:text-brand">
        {summary}
        <span
          aria-hidden="true"
          className="shrink-0 text-[13px] font-normal text-ink-subtle transition-transform group-open:rotate-180"
        >
          ▼
        </span>
      </summary>
      <div className="pb-5 text-[14px] leading-relaxed text-ink-muted">{children}</div>
    </details>
  );
}
